import styled from "styled-components";
import { useEffect, useState } from "react";

export const TabItemStyle = styled.li`
  padding-right: 2px;
  cursor: pointer;
  display: flex;
  &:hover {
    background-color: rgb(244, 244, 244);
  }
`;

export const TabStyle = styled.ul`
  list-style: none;
  display: flex;
`;

export type TabItemProps = {
  text: any;
  onClick: (text: string) => void;
  active: boolean;
  value: string;
  icon?: any;
  fontSize: number;
};

export type TabItemType = {
  key: string;
  value: any;
  icon?: any;
};

export type TabProps = {
  items: TabItemType[];
  value: string;
  icon?: any;
  fontSize?: number;
  onTabChange: (text: string) => void;
  rightAction?: any;
};

const Tab = ({ items, value, onTabChange, fontSize = 14, rightAction = null }: TabProps) => {
  const [activeTab, setActiveTab] = useState(value);

  useEffect(() => {
    setActiveTab(value);
  }, [value]);

  const onTabItemClick = (text: string) => {
    setActiveTab(text);
    if (onTabChange) onTabChange(text);
  };

  return (
    <div className="border-b border-gray-200">
      <nav
        aria-label="Activity tabs"
        className="-mb-px flex flex-col sm:flex-row sm:justify-between"
      >
        <div className="flex flex-wrap gap-1 sm:gap-1 sm:space-x-1 w-full min-w-0">
          {items.map((item: TabItemType, index: number) => (
            <button
              key={`${item.key}-${index}`}
              onClick={() => onTabItemClick(item.key)}
              className={`group inline-flex items-center justify-center px-3 py-2.5 text-xs sm:text-sm font-medium rounded-t-lg transition-colors duration-200 flex-shrink-0 sm:flex-none max-w-full ${
                activeTab === item.key
                  ? "bg-blue-50 text-blue-700 border-b-2 border-blue-500"
                  : "text-gray-500 hover:text-gray-700 hover:bg-gray-50 border-b-2 border-transparent"
              }`}
              style={{ fontSize: fontSize }}
            >
              {item.icon && (
                <span
                  className={`mr-1.5 sm:mr-2 h-3.5 w-3.5 sm:h-4 sm:w-4 flex-shrink-0 ${
                    activeTab === item.key
                      ? "text-blue-600"
                      : "text-gray-400 group-hover:text-gray-500"
                  }`}
                >
                  {item.icon}
                </span>
              )}
              <span className="break-words text-center">{item.value}</span>
            </button>
          ))}
        </div>
        {rightAction && <div className="flex items-center mt-3 sm:mt-0 sm:ml-4">{rightAction}</div>}
      </nav>
    </div>
  );
};

export default Tab;
